function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_903_222)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 56H14C13.45 56 13 55.55 13 55C13 54.45 13.45 54 14 54H35C35.55 54 36 53.55 36 53V45C36 44.45 35.55 44 35 44H7C6.45 44 6 43.55 6 43C6 42.45 6.45 42 7 42H35C36.65 42 38 43.35 38 45V53C38 54.65 36.65 56 35 56Z",
  fill: "url(#paint0_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 44C34.45 44 34 43.55 34 43V38C34 36.35 32.65 35 31 35H15C14.45 35 14 34.55 14 34C14 33.45 14.45 33 15 33H31C33.76 33 36 35.24 36 38V43C36 43.55 35.55 44 35 44Z",
  fill: "url(#paint1_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 35H7C6.45 35 6 34.55 6 34C6 33.45 6.45 33 7 33H11C11.55 33 12 33.45 12 34C12 34.55 11.55 35 11 35Z",
  fill: "url(#paint2_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.39 31H7C6.45 31 6 30.55 6 30C6 29.45 6.45 29 7 29H24.29L22.62 12H7C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10H23.53C24.04 10 24.48 10.39 24.53 10.9L26.39 29.9C26.42 30.18 26.33 30.46 26.14 30.67C25.94 30.88 25.67 31 25.39 31Z",
  fill: "url(#paint3_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 68H24C22.35 68 21 66.65 21 65V55C21 54.45 21.45 54 22 54C22.55 54 23 54.45 23 55V65C23 65.55 23.45 66 24 66H30C30.55 66 31 65.55 31 65V55C31 54.45 31.45 54 32 54C32.55 54 33 54.45 33 55V65C33 66.65 31.65 68 30 68Z",
  fill: "url(#paint4_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 60H22C21.45 60 21 59.55 21 59C21 58.45 21.45 58 22 58H25C25.55 58 26 58.45 26 59C26 59.55 25.55 60 25 60Z",
  fill: "url(#paint5_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 52H23C22.45 52 22 51.55 22 51V47C22 46.45 22.45 46 23 46H31C31.55 46 32 46.45 32 47V51C32 51.55 31.55 52 31 52ZM24 50H30V48H24V50Z",
  fill: "url(#paint6_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 54C11.45 54 11 53.55 11 53V43C11 42.45 11.45 42 12 42C12.55 42 13 42.45 13 43V53C13 53.55 12.55 54 12 54Z",
  fill: "url(#paint7_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 56C17.45 56 17 55.55 17 55V43C17 42.45 17.45 42 18 42C18.55 42 19 42.45 19 43V55C19 55.55 18.55 56 18 56Z",
  fill: "url(#paint8_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 31H30C29.45 31 29 30.55 29 30C29 29.45 29.45 29 30 29H35C35.55 29 36 28.55 36 28V24C36 23.45 35.55 23 35 23H29C28.45 23 28 22.55 28 22C28 21.45 28.45 21 29 21H35C36.65 21 38 22.35 38 24V28C38 29.65 36.65 31 35 31Z",
  fill: "url(#paint9_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 64H7C6.45 64 6 63.55 6 63V7C6 6.45 6.45 6 7 6H23.42C25.97 6 28.11 7.91 28.39 10.45L30.99 33.89C31.05 34.44 30.66 34.93 30.11 34.99C29.56 35.05 29.07 34.66 29.01 34.11L26.4 10.67C26.23 9.15 24.95 8 23.42 8H8V52H14C14.55 52 15 52.45 15 53V63C15 63.55 14.55 64 14 64ZM8 62H13V54H8V62Z",
  fill: "url(#paint10_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 36C47.83 36 42 30.17 42 23V7C42 6.45 42.45 6 43 6H67C67.55 6 68 6.45 68 7V23C68 30.17 62.17 36 55 36ZM44 8V23C44 29.07 48.93 34 55 34C61.07 34 66 29.07 66 23V8H44Z",
  fill: "url(#paint11_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 32C54.45 32 54 31.55 54 31C54 30.45 54.45 30 55 30C58.86 30 62 26.86 62 23C62 22.45 62.45 22 63 22C63.55 22 64 22.45 64 23C64 27.96 59.96 32 55 32Z",
  fill: "url(#paint12_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63 20C63.5523 20 64 19.5523 64 19C64 18.4477 63.5523 18 63 18C62.4477 18 62 18.4477 62 19C62 19.5523 62.4477 20 63 20Z",
  fill: "url(#paint13_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53 43C52.45 43 52 42.55 52 42V35C52 34.45 52.45 34 53 34C53.55 34 54 34.45 54 35V42C54 42.55 53.55 43 53 43Z",
  fill: "url(#paint14_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57 43C56.45 43 56 42.55 56 42V35C56 34.45 56.45 34 57 34C57.55 34 58 34.45 58 35V42C58 42.55 57.55 43 57 43Z",
  fill: "url(#paint15_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.0002 52H51.0002C50.6402 52 50.3002 51.8 50.1302 51.49L45.1302 42.49C44.9602 42.18 44.9602 41.8 45.1402 41.5C45.3202 41.19 45.6502 41 46.0002 41H65.0002C66.6502 41 68.0002 42.35 68.0002 44V51C68.0002 51.55 67.5502 52 67.0002 52ZM51.5902 50H66.0002V44C66.0002 43.45 65.5502 43 65.0002 43H47.7002L51.5902 50Z",
  fill: "url(#paint16_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.59 50H43C42.45 50 42 49.55 42 49V44C42 43.45 42.45 43 43 43H47C47.55 43 48 43.45 48 44C48 44.55 47.55 45 47 45H44V48H49.59C50.14 48 50.59 48.45 50.59 49C50.59 49.55 50.14 50 49.59 50Z",
  fill: "url(#paint17_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 48H41C40.45 48 40 47.55 40 47C40 46.45 40.45 46 41 46H43C43.55 46 44 46.45 44 47C44 47.55 43.55 48 43 48Z",
  fill: "url(#paint18_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M65 68H61C59.35 68 58 66.65 58 65V51C58 50.45 58.45 50 59 50C59.55 50 60 50.45 60 51V65C60 65.55 60.45 66 61 66H65C65.55 66 66 65.55 66 65V51C66 50.45 66.45 50 67 50C67.55 50 68 50.45 68 51V65C68 66.65 66.65 68 65 68Z",
  fill: "url(#paint19_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67 56H64C63.45 56 63 55.55 63 55C63 54.45 63.45 54 64 54H67C67.55 54 68 54.45 68 55C68 55.55 67.55 56 67 56Z",
  fill: "url(#paint20_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67 60H64C63.45 60 63 59.55 63 59C63 58.45 63.45 58 64 58H67C67.55 58 68 58.45 68 59C68 59.55 67.55 60 67 60Z",
  fill: "url(#paint21_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67 64H64C63.45 64 63 63.55 63 63C63 62.45 63.45 62 64 62H67C67.55 62 68 62.45 68 63C68 63.55 67.55 64 67 64Z",
  fill: "url(#paint22_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.0003 62C49.6303 62 49.2903 61.8 49.1203 61.47C48.9503 61.14 48.9603 60.75 49.1703 60.44C50.3703 58.64 51.0003 56.55 51.0003 54.39V51C51.0003 50.45 51.4503 50 52.0003 50C52.5503 50 53.0003 50.45 53.0003 51V54.39C53.0003 56.16 52.6403 57.88 51.9503 59.49C53.1703 58.8 54.0003 57.5 54.0003 56V51C54.0003 50.45 54.4503 50 55.0003 50C55.5503 50 56.0003 50.45 56.0003 51V56C56.0003 59.31 53.3103 62 50.0003 62Z",
  fill: "url(#paint23_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67 12H63C62.45 12 62 11.55 62 11C62 10.45 62.45 10 63 10H67C67.55 10 68 10.45 68 11C68 11.55 67.55 12 67 12Z",
  fill: "url(#paint24_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59 12H43C42.45 12 42 11.55 42 11C42 10.45 42.45 10 43 10H59C59.55 10 60 10.45 60 11C60 11.55 59.55 12 59 12Z",
  fill: "url(#paint25_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 60H29C28.45 60 28 59.55 28 59C28 58.45 28.45 58 29 58H32C32.55 58 33 58.45 33 59C33 59.55 32.55 60 32 60Z",
  fill: "url(#paint26_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25 64H22C21.45 64 21 63.55 21 63C21 62.45 21.45 62 22 62H25C25.55 62 26 62.45 26 63C26 63.55 25.55 64 25 64Z",
  fill: "url(#paint27_linear_903_222)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 64H29C28.45 64 28 63.55 28 63C28 62.45 28.45 62 29 62H32C32.55 62 33 62.45 33 63C33 63.55 32.55 64 32 64Z",
  fill: "url(#paint28_linear_903_222)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_903_222",
  x1: 22,
  y1: 42,
  x2: 22,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_903_222",
  x1: 25,
  y1: 33,
  x2: 25,
  y2: 44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_903_222",
  x1: 9,
  y1: 33,
  x2: 9,
  y2: 35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_903_222",
  x1: 16.1978,
  y1: 10,
  x2: 16.1978,
  y2: 31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_903_222",
  x1: 27,
  y1: 54,
  x2: 27,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_903_222",
  x1: 23.5,
  y1: 58,
  x2: 23.5,
  y2: 60,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_903_222",
  x1: 27,
  y1: 46,
  x2: 27,
  y2: 52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_903_222",
  x1: 12,
  y1: 42,
  x2: 12,
  y2: 54,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_903_222",
  x1: 18,
  y1: 42,
  x2: 18,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_903_222",
  x1: 33,
  y1: 21,
  x2: 33,
  y2: 31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_903_222",
  x1: 18.498,
  y1: 6,
  x2: 18.498,
  y2: 64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_903_222",
  x1: 55,
  y1: 6,
  x2: 55,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_903_222",
  x1: 59,
  y1: 22,
  x2: 59,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_903_222",
  x1: 63,
  y1: 18,
  x2: 63,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_903_222",
  x1: 53,
  y1: 34,
  x2: 53,
  y2: 43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_903_222",
  x1: 57,
  y1: 34,
  x2: 57,
  y2: 43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_903_222",
  x1: 56.502,
  y1: 41,
  x2: 56.502,
  y2: 52,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_903_222",
  x1: 46.295,
  y1: 43,
  x2: 46.295,
  y2: 50,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_903_222",
  x1: 42,
  y1: 46,
  x2: 42,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_903_222",
  x1: 63,
  y1: 50,
  x2: 63,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_903_222",
  x1: 65.5,
  y1: 54,
  x2: 65.5,
  y2: 56,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_903_222",
  x1: 65.5,
  y1: 58,
  x2: 65.5,
  y2: 60,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_903_222",
  x1: 65.5,
  y1: 62,
  x2: 65.5,
  y2: 64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_903_222",
  x1: 52.5011,
  y1: 50,
  x2: 52.5011,
  y2: 62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_903_222",
  x1: 65,
  y1: 10,
  x2: 65,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_903_222",
  x1: 51,
  y1: 10,
  x2: 51,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_903_222",
  x1: 30.5,
  y1: 58,
  x2: 30.5,
  y2: 60,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint27_linear_903_222",
  x1: 23.5,
  y1: 62,
  x2: 23.5,
  y2: 64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint28_linear_903_222",
  x1: 30.5,
  y1: 62,
  x2: 30.5,
  y2: 64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A80000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D0101"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_903_222"
}, /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 62,
  fill: "white",
  transform: "translate(6 6)"
})));

function SvgSmoothing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothing);
export default __webpack_public_path__ + "static/media/smoothing.0ebc0e36.svg";
export { ForwardRef as ReactComponent };